export const sessionKeys = {
  displayToggle: 'translation-key-toggle-show',
  active: 'translation-key-active',
  queryParamName: 'translationKeyToggle'
};
